export default "__VITE_ASSET__BEZ8Q3qg__"